module.exports = __webpack_public_path__ + "static/media/speach_round_ic.ec8afa60.svg";